<div class="head-nav-holder">
  <header class="d-flex justify-content-between align-items-center container theader px-0">
    <div class="header-icon-holder">
      <div class="logo">
        <img [src]="logoImage" alt="Logo">
      </div>

    </div>
  </header>
</div>
